import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, LanguageSelectorComponent],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [
    LoginService
  ]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  private _emailSentSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  public showEmailSent: Boolean = false;
  public showLoader: Boolean = false;
  public userEmail;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _errorService: ErrorHandler,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {

    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._copyService.getStaticCopy()
      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    this._emailSentSubscription = this._loginService.forgotPasswordEmailSent$
      .subscribe(emailSent => {
        if (emailSent.error) {
          this.handleErrors();
          return;
        }

        if (this.showEmailSent) {

          const data = {
            text: 'Email sent!',
            type: 'info',
            icon: 'alert',
            sticky: false
          };

          this._errorService.handleCustomInfo(data);
        }

        this.showEmailSent = emailSent;
      },
      err => console.log(err));

  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Password',
      ['resetPassword']
    );
    // console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  handleErrors() {
    this.showLoader = false;
  }

  goToLogin() {
    this._router.navigate(['login']);
  }

  handleSubmitForgotPassword(value, e) {
    e.preventDefault();
    this.showLoader = true;
    this.userEmail = value.email;
    this._loginService.sendResetPassword(value.email);
  }

  resendEmail() {
    this._loginService.sendResetPassword(this.userEmail, false);
  }

  ngOnDestroy() {
    this._emailSentSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
  }

}
